import { useDispatch, useSelector } from "react-redux";
import { setData } from "../../redux/app/Actions";
import { useScope } from "../../../container/SelectProjectCompanyContainer";
import { useEffect } from "react";

export const useFilter = (keyFilter = 'filter') => {
  const dispatch = useDispatch();
  const reload = useSelector((state) => state.app[`${keyFilter}-reload`]);
  const values = useSelector((state) => state.app[keyFilter] || []);
  const { scope } = useScope()

  const onChange = (field, value) => {
    if(values[field] !== value){
      if(field === 'projects'){
        if(value){
          dispatch(setData({
            [keyFilter]: {
              ...values,
              [field]: value
            }
          }))
        }
      } else {
        dispatch(setData({
          [keyFilter]: {
            ...values,
            [field]: value
          }
        }))
      }
    }
  }

  const onReload = () => {
    dispatch(setData({
      [`${keyFilter}-reload`]: !reload
    }))
  }

  useEffect(() => {
    if (scope?.id) {
      dispatch(setData({
        [keyFilter]: {}
      }))
    }
  }, [scope?.id])

  return [values, onChange, reload, onReload]
}